/**
 * Mirrors `$desktop-breakpoint` in `src/theme/_responsive.scss`: at and above this width the
 * layout shows the desktop sidebar instead of the mobile tab bar.
 */
export const DESKTOP_BREAKPOINT_PX: number = 768;

export function isDesktopViewport(): boolean {
  return typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia(`(min-width: ${DESKTOP_BREAKPOINT_PX}px)`).matches;
}
